import Vue from 'vue';

export default class User {
  public id = '';
  public firstName = '';
  public lastName = '';
  public name = '';
  public email = '';
  public verificationLink: '';
  public active = true;
  public kind: undefined | number = undefined;
  public kindName = '';
  public enterpriseId = '';
  public periodStart = '';
  public currentPeriodEnd = '';
  public sCustomerId = '';
  public subscriptionId = '';
  public sPlanId = '';
  public smsProtect = null;
  public stripeOveragePrice = null;
  public stripeSmsOveragePrice = null;
  public stripeIdentityOveragePrice = null;
  public lastOverageInvoicedAt = null;
  public trialComplete = '';
  public subscriptionInterval ='';
  public created = '';
  public stats = {};
  public quotaRenewedOn = '';
  public annualCommitmentMonthlyBilling = '';

  public kinds = {
    kind0: 'Free forever',
    kind1: 'API',
    kind2: 'Entrepreneur',
    kind3: 'Enterprise',
    kind4: 'Enterprise user',
    kind6: 'Trial',
    kind7: 'Business',
    kind8: 'Business pro',
  };

  public kindHash = [
    {
      kind: 0,
      name: 'Free forever',
      subscription: false,
    },
    {
      kind: 1,
      name: 'API',
      subscription: true,
    },
    {
      kind: 2,
      name: 'Entrepreneur',
      subscription: false,
    },
    {
      kind: 3,
      name: 'Enterprise',
      subscription: true,
    },
    {
      kind: 4,
      name: 'Enterprise user',
      subscription: false,
    },
    {
      kind: 6,
      name: 'Trial',
      subscription: false,
    },
    {
      kind: 7,
      name: 'Business',
      subscription: false,
    },
    {
      kind: 8,
      name: 'Business pro',
      subscription: false,
    },
  ]

  constructor(options) {
    this.id = options.id;
    this.active = options.active;
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.enterpriseId = options.enterpriseId;
    this.name = `${options.firstName} ${options.lastName}`;
    this.email = options.email;
    this.verificationLink = options.verificationLink;
    this.kindName = this.getKind(options.kind);
    this.kind = options.kind;
    if (typeof this.kind !== 'undefined') {
      this.kind = parseInt(options.kind, 10);
    }
    this.periodStart = options.periodStart;
    this.currentPeriodEnd = options.currentPeriodEnd;
    this.sCustomerId = options.sCustomerId;
    this.subscriptionId = options.subscriptionId;
    this.sPlanId = options.sPlanId;
    this.stripeOveragePrice = options.stripeOveragePrice;
    this.stripeSmsOveragePrice = options.stripeSmsOveragePrice;
    this.stripeIdentityOveragePrice = options.stripeIdentityOveragePrice;
    this.lastOverageInvoicedAt = options.lastOverageInvoicedAt;
    this.trialComplete = options.trialComplete;
    this.subscriptionInterval = options.subscriptionInterval;
    this.created = options.created;
    this.stats = options.stats;
    this.smsProtect = options.smsProtect;
    this.quotaRenewedOn = options.quotaRenewedOn;
    this.annualCommitmentMonthlyBilling = options.annualCommitmentMonthlyBilling;
  }

  public getKindName(): string {
    if (typeof this.kind === 'undefined') {
      return '';
    }

    const name = this.kindHash.find((item) => item.kind === this.kind)?.name;

    if (!name) {
      return '';
    }

    return name;
  }

  public getKind(kind) {
    const kindNumber = parseInt(kind, 10);

    return this.kinds[`kind${kindNumber}`];
  }

  public subscriptionUrl() {
    return Vue.prototype.$billingProviderUrl[process.env.VUE_APP_PROVIDER].subscription(
      this.subscriptionId,
    );
  }

  public customerUrl() {
    return Vue.prototype.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(
      this.sCustomerId,
    );
  }

  public fullName(): string {
    return `${this.name} (${this.email})`;
  }
}
